import TeamMain from '../views/teamlist/teamHome.vue'
const appRouter = [
  {
    path: '/',
    redirect: '/teamcontent/index',
    // name: 'index',
    component: () => import('@/views/teamlist/teamHome'),
  },
  {
    path: '/org/:orgname',
    name: 'org',
    component: () => import('@/views/pcTemList/newOrg')
  },
  {
    path: '/live',
    name: 'live',
    component: () => import('@/views/live/live.vue'),
  },
  {
    path: '/newlive',
    name: 'newlive',
    component: () => import('@/views/live/newlive.vue'),
  },
  { //团队pc端
    path: '/teamcontent',
    // redirect: 'teamcontent/index',
    component: TeamMain,
    children: [
      {
        path: 'index',
        name: 'index',
        component: () => import('@/views/pcTemList/orgindex'),
      },
      {
        path: 'knowledge', //团队知识
        name:'knowledge',
        component: () => import('@/views/pcTemList/knowledge'),
      },
      {
        path: 'voice', //团队知识
        name:'voice',
        component: () => import('@/views/pcTemList/voice'),
      },
      {
        path: 'artDetail',
        name: 'artDetail',
        component: () => import('@/views/pcTemList/artDetail'),
      },
      {
        path: 'voiceDetail',
        name: 'voiceDetail',
        component: () => import('@/views/pcTemList/voiceDetail'),
      },
      {
        path: 'searchList',
        name: 'searchList',
        component: () => import('@/views/pcTemList/searchList'),
      },
      {
        path: 'docInfo',
        name: 'docInfo',
        component: () => import('@/views/pcTemList/docInfo'),
      },

    ]
  },
  {
    path: '/docFam/docSay',
    component: () => import('@/views/doctorindex/doctorindex'),
    children: [{
        path: 'aboutVoice', //医生语音
        component: () => import('@/views/doctorindex/doctorvoice'),
      },
      {
        path: 'doctorartcile', //医生文章
        component: () => import('@/views/doctorindex/doctorartcile'),
      },
      {
        path: 'appearance', //医生风采
        component: () => import('@/views/doctorindex/appearance'),
      },
    ]
  },
  { //团队列表页
    path: '/teamlist',
    component: () => import('@/views/teamlist/teamlist'),
  },
  { //个人介绍页
    path: '/introduce',
    component: () => import('@/views/doctorindex/introduce'),
  },
  { //文章详情页
    path: '/paragraph/:deviceId',
    component: () => import('@/components/doctorkonwlege/paragraph'),
  },
  { //语音详情页
    path: '/voiceContent',
    component: () => import('@/components/doctorkonwlege/voiceContent'),
  },
  {
    path: '/print',
    component: () => import('@/views/print/print'),
  },
  {

    path: '/prints',
    component: () => import('@/views/print/prints'),

    path: '/followHypertensionPrint',
    component: () => import('@/views/print/followHypertensionPrint'),
  },
  //  followDiabetesPrint 糖尿病随访表单
  {
    path: '/followDiabetesPrint',
    component: () => import('@/views/print/followDiabetesPrint'),
  },
  // identificationTCMShowPrint 中医体质辨识
  {
    path: '/identificationTCMShowPrint',
    component: () => import('@/views/print/identificationTCMShowPrint'),
  },
  // selfCareAbilityShowPrint 老年人自理能力辨识
  {
    path: '/selfCareAbilityShowPrint',
    component: () => import('@/views/print/selfCareAbilityShowPrint'),

  },
]
export default appRouter;



// WEBPACK FOOTER //
// ./src/router/pcrouter.js